import { render, staticRenderFns } from "./invoiceDetailDialog.vue?vue&type=template&id=04904b6a&scoped=true"
import script from "./invoiceDetailDialog.vue?vue&type=script&lang=js"
export * from "./invoiceDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetailDialog.vue?vue&type=style&index=0&id=04904b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04904b6a",
  null
  
)

export default component.exports